var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-search-query-labels" } },
    _vm._l(_vm.queryParamLabels, function (label, index) {
      return _c(
        "span",
        { key: index, attrs: { "data-label": "search-param-label" } },
        [_c("span", { staticClass: "text" }, [_vm._v(_vm._s(label))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }